import React, {useEffect, useState} from "react";
import {Link} from 'react-router-dom';
import {useNavigate} from "react-router-dom";
import '../styles/Inicio.css';

/* Iconos */
import pdf_icon from '../imagenes/icons/pdf.gif';
import job_icon from '../imagenes/icons/job.gif';
import mail_icon from '../imagenes/icons/mail.gif';
import exp_icon from '../imagenes/icons/exp.gif';
import desk_icon from '../imagenes/icons/desk.gif';
import employees_icon from '../imagenes/icons/employees.gif';
import notes_icon from '../imagenes/icons/notes.gif';
import public_image_icon from '../imagenes/icons/image.gif';
import galery_icon from '../imagenes/icons/galeria.gif';


/* Docs */
import tupa_pdf from '../documentos/TUPA-2025.pdf';
import PPRRD_pdf from '../documentos/PPRRD-2022-2025.pdf';
import MCC_pdf from '../documentos/MCC-2025.pdf';
import TUSNE_pdf from '../documentos/TUSNE_2025.pdf';
import Cod_Etica_pdf from '../documentos/CODIGO_DE_ETICA_2025.pdf';
import noticia01_pdf from '../documentos/noticias/NOTICIA01.pdf';
import noticia01_02_pdf from '../documentos/noticias/NOTICIA01_02.pdf';
import noticia02_pdf from '../documentos/noticias/NOTICIA02.pdf';
import noticia03_pdf from '../documentos/noticias/NOTICIA03.pdf';
import noticia04_pdf from '../documentos/noticias/NOTICIA04.pdf';
import noticia05_pdf from '../documentos/noticias/NOTICIA05.pdf';
import noticia06_pdf from '../documentos/noticias/NOTICIA06.pdf';
import noticia07_pdf from '../documentos/PLAN-DE-CONTINUIDAD-OPERATIVA-2024-2026.pdf';
import noticia08_pdf from '../documentos/noticias/NOTICIA08.pdf';
import noticia09_pdf from '../documentos/noticias/NOTICIA09.pdf';
import CMN_2026_pdf from '../documentos/CMN_2026.pdf';
import noticia10_pdf from '../documentos/noticias/NOTICIA10.pdf';

/* Fotos Noticias */
import not01 from '../imagenes/portadaPDF/aviso01.jpg';
import not01_02 from '../imagenes/portadaPDF/aviso01_02.jpg';
import not02 from '../imagenes/portadaPDF/aviso02.jpg';
import not03 from '../imagenes/portadaPDF/aviso03.jpg';
import not04 from '../imagenes/portadaPDF/aviso04.jpg';
import not05 from '../imagenes/portadaPDF/aviso05.jpg';
import not06 from '../imagenes/portadaPDF/aviso06.jpg';
import not07 from '../imagenes/portadaPDF/aviso07.jpg';
import not08 from '../imagenes/portadaPDF/aviso08.jpg';
import not09 from '../imagenes/portadaPDF/aviso09.jpg';
import not10 from '../imagenes/portadaPDF/aviso10.jpg';
import not11 from '../imagenes/portadaPDF/aviso11.jpg';

/*Fotos convocatorias procesos*/
import notP01 from '../imagenes/portadaPDFProcesos/10.jpg';
import notP02 from '../imagenes/portadaPDFProcesos/0.jpg';
import notP03 from '../imagenes/portadaPDFProcesos/Bases_Integradas.jpg';
import notP04 from '../imagenes/portadaPDFProcesos/Ampliacion.jpg';
import notP05 from '../imagenes/portadaPDFProcesos/Ampliacion02.jpg';
import notP06 from '../imagenes/portadaPDFProcesos/Ampliacion03.jpg';
import notP07 from '../imagenes/portadaPDFProcesos/ACTA_DE_RECEPCION_DE_PROPUESTAS.jpg';
import notP08 from '../imagenes/portadaPDFProcesos/ACTA_DE_EVALUACION_DE_PROPUESTAS.jpg';
import notP09 from '../imagenes/portadaPDFProcesos/ACTA_DE_ADJUDICACION_DE_LA_BUENA_PRO.jpg';
import notP10 from '../imagenes/portadaPDFProcesos/BASES_PROCESO_DE_SELECCION_001_2026_MPCH_MAEZTRANZA_page-0001.jpg';
import notP11 from '../imagenes/portadaPDFProcesos/BASES_SELECCION_SUPERVISION_LINEA_AMARILLA_2026.jpg';
/*Docs convocatorias procesos*/
import bases_convo_pdf from '../documentos/convocatorias_procesos/BASES_DEL_PROCESO_DE_SELECCION.pdf';
import publi_convo_pdf from '../documentos/convocatorias_procesos/PUBLICACION_EN_EL_PERUANO_PAG.11_REV_3.pdf';
import bases_01_convo_pdf from '../documentos/convocatorias_procesos/BASES_INTEGRADAS.pdf';
import ampliacion_pdf from '../documentos/convocatorias_procesos/CIRCULAR_N_01_2025_COMITE_ESPECIAL_MPCH_MODIFICACION_DE_CALENDARIO.pdf';
import ampliacion_02_pdf from '../documentos/convocatorias_procesos/CIRCULAR_N_02_2025_COMITE_ESPECIAL_MPCH_MODIFICACION_DE_CALENDARIO.pdf';
import ampliacion_03_pdf from '../documentos/convocatorias_procesos/CIRCULAR_N_03_2025_COMITE_ESPECIAL_MPCH_MODIFICACION_DE_CALENDARIO.pdf';
import acta_recepcion_propuestas from '../documentos/convocatorias_procesos/ACTA_DE_RECEPCION_DE_PROPUESTAS.pdf';
import acta_evaluacion_propuestas from '../documentos/convocatorias_procesos/ACTA_DE_EVALUACION_DE_PROPUESTAS.pdf';
import acta_adjudicacion_buena_pro from '../documentos/convocatorias_procesos/ACTA_DE_ADJUDICACION_DE_LA_BUENA_PRO.pdf';
import bases_01_2026_pdf from '../documentos/convocatorias_procesos/BASES_PROCESOS_DE_SELECCION_001_2026_MPCH-C-MAEZTRANZA.pdf';
import bases_02_2026_pdf from '../documentos/convocatorias_procesos/BASES_SELECCION_SUPERVISION_LINEA_AMARILLA_2026.pdf';
/* Fotos SPAM */
import imagen01 from '../imagenes/spamSlider/imagen07.jpg';
import imagen02 from '../imagenes/spamSlider/imagen08.jpg';
import imagen03 from '../imagenes/spamSlider/imagen09.jpg';
import imagen04 from '../imagenes/spamSlider/imagen10.jpg';
import imagen05 from '../imagenes/spamSlider/imagen11.jpg';
//import imagen03 from '../imagenes/spamSlider/imagen03.jpg';

/* Fotos slider*/
import Imagen_01 from '../imagenes/PORTADA_2026_1.jpeg';
import Imagen_02 from '../imagenes/PORTADA_2026_2.jpeg';
import Imagen_03 from '../imagenes/PORTADA_2026_7.jpg';
import Imagen_04 from '../imagenes/PORTADA_2025_6.png';



/* Funciones */
function Inicio(){
  return(
    <>
      <Slider/>
      <LinkSection/>
      <NoticiasPDF/>
      <ConvocatoriaProceso/>
      <Render/>
    </>
  );
}
export default Inicio;

function Slider(){
  const slides = [
    {
      id: 1,
      imagen: Imagen_03,
    },
    {
      id: 2,
      imagen: Imagen_04,
    },
    {
      id: 3,
      imagen: Imagen_01,
    },
  ];
  const [index, setIndex] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % slides.length);
    }, 10000); // cambia cada 10 segundos
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="slider-container">
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`slide ${i === index ? 'active' : 'inactive'}`}
        >
          <img src={slide.imagen}></img>
        </div>
      ))}
    </div>
  );
};

function LinkSection(){
  const links = [
    { icon: pdf_icon, text: 'PEI 2024-2028', url: '#' },
    { icon: pdf_icon, text: 'TUPA 2025', url: tupa_pdf },
    { icon: pdf_icon, text: 'PPRRD: 2022 - 2025', url: PPRRD_pdf},
    { icon: mail_icon, text: 'Correo Institucional', url: 'https://munichumbivilcas.gob.pe:2096/' },
    { icon: desk_icon, text: 'Mesa de Partes Virtual', url: 'https://munichumbivilcas.gob.pe/sgd/tramite_externo.php' },
    { icon: employees_icon, text: 'Directorio', url: 'https://www.gob.pe/institucion/munichumbivilcas/funcionarios' },
    { icon: pdf_icon, text: 'MCC 2025', url: MCC_pdf },
    { icon: pdf_icon, text: 'TUSNE 2025', url: TUSNE_pdf },
    { icon: pdf_icon, text: 'Código de Ética 2025', url: Cod_Etica_pdf },
  ];

  return (
    <section className="links-section">
      <h2>Enlaces de Interés</h2>
      <div className="links-grid">
        <Link to='/Convocatorias' className='link-item'>
          <img src={job_icon} className='link-icon'></img>
          <span className='text'>Convocatorías CAS</span>
        </Link>
        <Link to='/Expedientes' className='link-item'>
          <img src={exp_icon} className='link-icon'></img>
          <span className='text'>Expedientes Técnicos</span>
        </Link>
        <Link to='/Galeria' className='link-item'>
          <img src={galery_icon} className='link-icon'></img>
          <span className='text'>Galeria Institucional</span>
        </Link>
        {links.map((link, index) => (
          <a key={index} href={link.url} className="link-item" target="_blank" rel="noopener noreferrer">
            <img src={link.icon} alt={link.text} className='link-icon'/>
            <span className="text">{link.text}</span>
          </a>
        ))}
      </div>
    </section>
  );
};

function NoticiasPDF(){
  const noticias = [
    {
      
      titulo: "Comunicado Recuperacion de dia no laborable",
      pdf: noticia10_pdf,
      imagen: not11
    },
    {
      titulo: "Procedimiento del cambio de Zonificación",
      pdf: noticia08_pdf,
      imagen: not09
    },
    {
      titulo: "Cuadro Multianual de Necesidades - 2026",
      pdf: CMN_2026_pdf,
      imagen: not08
    },
    {
      titulo: "Plan de Continuidad Operativa 2024-2026",
      pdf: noticia07_pdf,
      imagen: not07
    },
    {
      titulo: "Saneamiento Fisico Legal del Inmueble Estatal",
      pdf: noticia06_pdf,
      imagen: not06
    },
    {
      titulo: "Amnistia Tributaria del Impuesto Predial 2025",
      pdf: noticia01_pdf,
      imagen: not01
    },
    {
      titulo: "Ampliacion Amnistia Tributaria del Impuesto Predial 2025",
      pdf: noticia01_02_pdf,
      imagen: not01_02
    },
    /*{
      titulo: "Proceso N° 001-2025-MPCH/C - Primera Convocatoria",
      pdf: noticia02_pdf,
      imagen: not02
    },
    {
      titulo: "Modelo Bases de Proceso de Selección de la Empresa Privada",
      pdf: noticia03_pdf,
      imagen: not03
    },*/
    {
      titulo: "Reglamento: Presupuesto Participativo MultiAnual",
      pdf: noticia04_pdf,
      imagen: not04
    },
    {
      titulo: "Brechas de Infraestructura | PMI 2025-2027",
      pdf: noticia05_pdf,
      imagen: not05
    }
  ];
  return (
    <section className="noticias-section">
      <h2>Noticias Importantes</h2>
      <div className="noticias-grid">
        {noticias.map((item, index) => (
          <div className="noticia-card" key={index}>
            <img src={item.imagen} alt={item.titulo} className="noticia-img" />
            <h3>{item.titulo}</h3>
            <a href={item.pdf} target="_blank" rel="noopener noreferrer" className="ver-btn">
              Ver Documento
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

function ConvocatoriaProceso(){
  const noticias = [
    {
      titulo: "BASES DEL PROCESO DE SELECCION - LINEA AMARILLA",
      pdf: bases_01_2026_pdf,
      imagen: notP10
    },
    {
      titulo: "BASES DEL PROCESO DE SELECCION - MAEZTRANZA",
      pdf: bases_02_2026_pdf,
      imagen: notP11
    }
    
    /*{
      titulo: "BASES DEL PROCESO DE SELECCION",
      pdf: bases_convo_pdf,
      imagen: notP01
    },
    {
      titulo: "PUBLICACION EN EL PERUANO PAG.11 REV 3",
      pdf: publi_convo_pdf,
      imagen: notP02
    },
    {
      titulo: "BASES INTEGRADAS DEL PROCESOS DE SELECCION",
      pdf: bases_01_convo_pdf,
      imagen: notP03
    },
    {
      titulo: "CIRCULAR N 01: MODIFICACIÓN DEL CALENDARIO",
      pdf: ampliacion_pdf,
      imagen: notP04
    },
    {
      titulo: "CIRCULAR N 02: MODIFICACIÓN DEL CALENDARIO",
      pdf: ampliacion_02_pdf,
      imagen: notP05
    },
    {
      titulo: "CIRCULAR N 03: MODIFICACIÓN DEL CALENDARIO",
      pdf: ampliacion_03_pdf,
      imagen: notP06
    },
    {
      titulo: "ACTA DE RECEPCION DE PROPUESTAS",
      pdf: acta_recepcion_propuestas,
      imagen: notP07
    },
    {
      titulo: "ACTA DE EVALUACION DE PROPUESTAS",
      pdf: acta_evaluacion_propuestas,
      imagen: notP08
    },
    {
      titulo: "ACTA DE ADJUDICACION DE LA BUENA PRO",
      pdf: acta_adjudicacion_buena_pro,
      imagen: notP09
    }*/
  ];
  return (
    <section className="noticias-section">
      <h2>Convocatorias para Procesos de Seleccion</h2>
      <div className="noticias-grid">
        {noticias.map((item, index) => (
          <div className="noticia-card" key={index}>
            <img src={item.imagen} alt={item.titulo} className="noticia-img" />
            <h3>{item.titulo}</h3>
            <a href={item.pdf} target="_blank" rel="noopener noreferrer" className="ver-btn">
              Ver Documento
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

function Render(){
  return(
    <div className='render'>
      <section>
        <h2>Notas de Prensa</h2>
        <iframe
          src='https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmunichumbivilcas&tabs=timeline&width=1240&height=600&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId'
          className='facebook-iframe'
        ></iframe>
      </section>
      <section>
        <h2>Ubicación</h2>
        <iframe
          src='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3863.6209158896604!2d-72.081905!3d-14.448997000000002!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xeb1fcf09065b30b3!2sMunicipalidad%20Provincial%20de%20Chumbivilcas!5e0!3m2!1ses-419!2spe!4v1633549934090!5m2!1ses-419!2spe'
          className='map-iframe'
        ></iframe>
      </section>
    </div>
  );
};

/*function Spam(){
  const images = [
    { src: imagen01 },
  ]
  const [visible, setVisible] = useState(true);
  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(true);

  // Cambio automático de imágenes
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Fade-out
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % images.length);
        setFade(true); // Fade-in
      }, 950);
    }, 10500);
    return () => clearInterval(interval);
  }, [images.length]);

  const nextImage = () => {
    setFade(false);
    setTimeout(() => {
      setCurrent((prev) => (prev + 1) % images.length);
      setFade(true);
    }, 400);
  };

  const prevImage = () => {
    setFade(false);
    setTimeout(() => {
      setCurrent((prev) =>
        prev === 0 ? images.length - 1 : prev - 1
      );
      setFade(true);
    }, 400);
  };

  if (!visible) return null;
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-btn" onClick={() => setVisible(false)}>✖</button>

        <div className="spam-container">
          <a href={images[current].link}>
            <img
              src={images[current].src}
              alt={`slide-${current}`}
              className={`spam-image ${fade ? "fade-in" : "fade-out"}`}
            />
          </a>

          <div className="controls">
            <button onClick={prevImage} className="nav-btn prev">❮</button>
            <button onClick={nextImage} className="nav-btn next">❯</button>
          </div>
        </div>
      </div>
    </div>
  );
};*/

function Spam(){
  const navigate = useNavigate();
  const images = [
    { src: imagen01, title: "CONCURSO HUAYLIA CHUMBIVILCANA 2025" },
    { src: imagen02, title: "CONCURSO HUAYLIA CHUMBIVILCANA 2025" },
    { src: imagen03, title: "CONCURSO HUAYLIA CHUMBIVILCANA 2025" },
    { src: imagen04, title: "CONCURSO HUAYLIA CHUMBIVILCANA 2025" },
    { src: imagen05, title: "CONCURSO HUAYLIA CHUMBIVILCANA 2025" },
  ];

  const [visible, setVisible] = useState(true);
  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(true);

  // Cambio automático de imágenes
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Fade-out
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % images.length);
        setFade(true); // Fade-in
      }, 950);
    }, 10500);
    return () => clearInterval(interval);
  }, [images.length]);

  const nextImage = () => {
    setFade(false);
    setTimeout(() => {
      setCurrent((prev) => (prev + 1) % images.length);
      setFade(true);
    }, 400);
  };

  const prevImage = () => {
    setFade(false);
    setTimeout(() => {
      setCurrent((prev) =>
        prev === 0 ? images.length - 1 : prev - 1
      );
      setFade(true);
    }, 400);
  };
  
  const handleClick = (title) => {
    // Redirige a la página Concursos y envía el nombre del concurso seleccionado
    navigate("/concursos", { state: { selected: title } });
  };

  if (!visible) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-btn" onClick={() => setVisible(false)}>✖</button>

        <div className="spam-container">
          <a href={images[current].link}>
            <img
              src={images[current].src}
              alt={`slide-${current}`}
              className={`spam-image ${fade ? "fade-in" : "fade-out"}`}
              onClick={() => handleClick(images[current].title)}
            />
          </a>

          <div className="controls">
            <button onClick={prevImage} className="nav-btn prev">❮</button>
            <button onClick={nextImage} className="nav-btn next">❯</button>
          </div>
        </div>
      </div>
    </div>
  );
};
